module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/performance-black_gris.1edf5af2.svg";